import { appFormUtil } from 'modules/common';
import React, { useEffect } from 'react';

import {
  useSaveMetaPhotoMutation,
  SaveMetaPhoto_Input
} from 'generated/graphql';

export type IFormState = {
  id: string;
  clientReportId: string;
  apiFileQueue: string[];
  uploadCount: number;
  photoCount: number;
  isUploading: boolean;
};

const initialState: IFormState = {
  apiFileQueue: [],
  id: '',
  clientReportId: '',
  uploadCount: 0,
  photoCount: 0,
  isUploading: false
};

export function useFormState(clientReportId: string) {
  const { formState, dispatch, genFieldProps } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      apiFileQueue: {
        label: 'Api file id',
        type: 'text'
      },
      id: {
        label: 'Id',
        type: 'text'
      }
    }
  });

  useEffect(
    () => {
      if (clientReportId !== '' && formState.clientReportId === '') {
        dispatch({
          type: 'UPDATE',
          payload: {
            property: 'clientReportId',
            value: clientReportId
          }
        });
      }
      return () => {};
    }, [
      clientReportId,
      dispatch,
      formState.clientReportId
    ]
  );

  useEffect(() => {
    if (formState.uploadCount > 0 && formState.uploadCount === formState.photoCount && formState.isUploading) {
      dispatch({
        type: 'UPDATE',
        payload: {
          property: 'isUploading',
          value: false
        }
      });
    }
    if (formState.uploadCount > 0 && formState.uploadCount > formState.photoCount && !formState.isUploading) {
      dispatch({
        type: 'UPDATE',
        payload: {
          property: 'isUploading',
          value: true
        }
      });
    }
  }, [
    dispatch,
    formState.apiFileQueue.length,
    formState.isUploading,

    formState.uploadCount,
    formState.photoCount
  ]);

  const [fnSavePhoto] = useSaveMetaPhoto();
  useEffect(() => {
    const tempState = [...formState.apiFileQueue];
    if (tempState.length > 0) {

      const fileId: string = tempState.shift() ?? '';
      (async () => {
        await fnSavePhoto({
          clientReportId: formState.clientReportId,
          apiFileId: fileId
        });
      })();
      dispatch({
        type: 'BATCH_UPDATE',
        payload: {
          ...formState,
          apiFileQueue: tempState,
          photoCount: formState.photoCount + 1
        }
      });

    }
  }, [
    dispatch,
    fnSavePhoto,
    formState,
    formState.apiFileQueue,
    formState.isUploading,
    formState.clientReportId
  ]);

  return React.useMemo(
    () => {

      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}

export function useSaveMetaPhoto() {
  const [
    fnMutate,
    tuple
  ] = useSaveMetaPhotoMutation({
    refetchQueries: []
  });
  const fnWrappedMutate = React.useCallback(
    async (input: SaveMetaPhoto_Input) => {
      await fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
